import {
	ArrayMinSize,
	IsArray,
	IsEnum,
	IsNotEmpty,
	IsOptional,
	IsString,
	IsUUID,
	ValidateNested,
} from 'class-validator';
import { MailingListChannelTypesEnum } from '../../enums/mailing-list-types.enum';
import { UserDto, NotificationAdditionalDataDto } from '.';
import { UserFilter } from '../filters';
import { Type } from 'class-transformer';
import { MailingListToUserStatusEnum, NotificationTypesEnum } from '../../enums';

export class MailingListData {
	@IsNotEmpty()
	@IsString()
	public title: string;

	@IsOptional()
	@IsNotEmpty()
	@IsString()
	public content: string;

	@IsNotEmpty()
	@IsArray()
	@ArrayMinSize(1)
	@IsEnum(MailingListChannelTypesEnum, { each: true })
	public useChannels: MailingListChannelTypesEnum[];

	@IsOptional()
	@IsNotEmpty()
	@IsUUID()
	public notificationType?: NotificationTypesEnum;

	@IsOptional()
	@IsUUID()
	public eventId?: string;

	@IsOptional()
	public notificationAdditionalData?: NotificationAdditionalDataDto;

	@IsOptional()
	@IsUUID()
	public authorId?: string;
}

export class MailingListDto {
	public id: string;
	public authorId: string;

	public data: MailingListData;
	public filters: UserFilter;

	public scheduledAt?: Date;

	public createdAt: Date;
	public updatedAt: Date;
	public deletedAt?: Date;

	public filteredUserIds?: string[];

	public author?: UserDto;
	public mailingToUsers?: MailingListToUserDto[];
}

export class MailingListToUserDto {
	public id: string;

	public mailingListId: string;
	public userId: string;

	public status: MailingListToUserStatusEnum;
	public sentAt?: Date;

	public createdAt: Date;
	public updatedAt: Date;
	public deletedAt?: Date;

	public user?: UserDto;
	public mailingList?: MailingListDto;
}

export class CreateMailingListDto {
	@IsNotEmpty()
	@ValidateNested()
	@Type(() => MailingListData)
	public data: MailingListData;

	@IsNotEmpty()
	@ValidateNested()
	@Type(() => UserFilter)
	public filters: UserFilter;

	public authorId?: string;
	public scheduledAt?: Date;
}

export class InviteEventMailingDto {
	@IsUUID()
	@IsNotEmpty()
	eventId: string;

	@IsNotEmpty()
	@IsString()
	instance: Date;

	@IsOptional()
	@IsNotEmpty()
	@IsUUID()
	invitationAuthorId?: string;

	@IsNotEmpty()
	filters: UserFilter;

	@IsArray()
	@IsNotEmpty()
	@ArrayMinSize(1)
	useChannels?: MailingListChannelTypesEnum[];
}
